import { id, Identifiable, Project, role } from "@planzone/dto";
import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getProjectRole({ uuid }: Identifiable<Project>) {
      const req = getState().find(({ project }) => project.uuid === uuid);

      return req ? req.role : { ...role, uuid: id };
    },
    isRetrieveProjectRoleRequestFailure({ uuid }: Identifiable<Project>) {
      const req = getState().find(({ project }) => project.uuid === uuid);

      return req ? req.request.isFailure : false;
    },
    isRetrieveProjectRoleRequestPending({ uuid }: Identifiable<Project>) {
      const req = getState().find(({ project }) => project.uuid === uuid);

      return req ? req.request.isPending : false;
    },
    isRetrieveProjectRoleRequestSuccess({ uuid }: Identifiable<Project>) {
      const req = getState().find(({ project }) => project.uuid === uuid);

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
